import { render } from "./Tutorial.vue?vue&type=template&id=64870ab5&scoped=true"
import script from "./Tutorial.vue?vue&type=script&lang=js"
export * from "./Tutorial.vue?vue&type=script&lang=js"

import "./Tutorial.vue?vue&type=style&index=0&id=64870ab5&lang=scss&scoped=true"

import exportComponent from "/Users/emmanueledurante/Documents/Lavoro/Martech/Whappy1/whappy-app-front-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64870ab5"]])

export default __exports__